import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from "axios"
import Cookies from 'js-cookie'
import { handleAlert } from '../functions/handleAlert'

export const getEmailsSentList=createAsyncThunk("emailsSentList/getEmailsSentList",async()=>{
  const token = Cookies.get(`${process.env.REACT_APP_TOKEN_NAME}`) 
  const res = await axios.get(`${process.env.REACT_APP_SERVER_URL}/dashboard/listRecentActivities`,{
    headers:{
      Authorization:`Bearer ${token}`
    }
  })
  console.log(res)
  return res.data.data
})

const initialState = {
  emailsSentList:0,
  isLoading:true
}

export const emailsSentListSlice = createSlice({
  name: 'emailsSentList',
  initialState,
  reducers: {
  },
  extraReducers:(builder)=>{
    builder.addCase(getEmailsSentList.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(getEmailsSentList.fulfilled, (state, { payload }) => {
      state.emailsSentList = payload
      state.isLoading = false
    })
    builder.addCase(getEmailsSentList.rejected, (_, action) => {
      if (action.payload) {
        handleAlert(action.payload.errorMessage , "error") 
      } else {
        handleAlert(action.error.message, "error") 
      }
    })
  }
})

export default emailsSentListSlice.reducer